import {
  ContactRoleProducer as BaseContactRole,
  GlobalBookResourceId,
} from '@eigtech/contacts-types'

const globalBookToRoleMap = {
  carrier: 'carrier',
  csr: 'csr',
  deskAdjuster: 'deskAdjuster',
  fieldAdjuster: 'fieldAdjuster',
  fieldTechnician: 'fieldTechnician',
  projectManager: 'projectManager',
  reviewer: 'reviewer',
  subcontractor: 'subcontractor',
} satisfies Record<GlobalBookResourceId, BaseContactRole>

export const getDefaultRoleFromBookName = (bookName: string) => {
  const role = globalBookToRoleMap[bookName as GlobalBookResourceId]

  return role as typeof role | undefined
}
